import type {WorkDetail} from "@novel/contracts";
export type WorkInfo=Pick<WorkDetail,"title"|"genre"|"synopsis">;
export const workInfo=(work:WorkInfo):WorkInfo=>({title:work.title,genre:work.genre,synopsis:work.synopsis});
export const infoLabels={title:"作品名",genre:"题材",synopsis:"简介"};
export type InfoField=keyof WorkInfo;
export function mergeWorkInfo(base:WorkInfo,local:WorkInfo,remote:WorkInfo,choices:Partial<Record<InfoField,"local"|"remote">>){
 const value={...local},conflicts:InfoField[]=[];
 for(const key of Object.keys(infoLabels) as InfoField[]){
  if(local[key]===remote[key]||remote[key]===base[key])continue;
  if(local[key]===base[key])value[key]=remote[key];
  else{conflicts.push(key);if(choices[key]==="remote")value[key]=remote[key];}
 }
 return {value,conflicts};
}
